import type { ClinicModuleStateDto, ModuleName } from "@dentacore/shared-types";

import { api } from "./client";

/**
 * Which add-on modules this clinic has (STORY-188b, MOD-D11).
 *
 * **A teaser only.** The server refuses every request to a module the clinic
 * does not have, whatever this says, so nothing is built on top of it as though
 * it were the check. Clinic-level, not branch-scoped.
 */
export function readClinicModules(signal?: AbortSignal): Promise<ClinicModuleStateDto[]> {
  return api<ClinicModuleStateDto[]>("/clinic/modules", { signal });
}

/** Ask for a module the clinic does not have. Sends nothing; an operator sees the note. */
export function requestClinicModule(module: ModuleName): Promise<ClinicModuleStateDto[]> {
  return api<ClinicModuleStateDto[]>(`/clinic/modules/${module}/request`, {
    method: "POST",
    body: {},
  });
}
